﻿type Noop = () => void;

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class Utils {
    static readonly noop: Noop = () => {
        // Do nothing
    };

    static isString(maybe): maybe is string {
        return typeof maybe === `string`;
    }

    static isNumber(maybe): maybe is number {
        return typeof maybe === `number`;
    }

    static isArray<T = unknown>(a): a is T[] {
        return Array.isArray(a);
    }
}
